import { render, staticRenderFns } from "./trainDetails.vue?vue&type=template&id=66eb0e43&scoped=true&"
import script from "./trainDetails.vue?vue&type=script&lang=ts&"
export * from "./trainDetails.vue?vue&type=script&lang=ts&"
import style0 from "./trainDetails.vue?vue&type=style&index=0&id=66eb0e43&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66eb0e43",
  null
  
)

export default component.exports